export default __webpack_public_path__ + "static/media/BlockAll.407d778b.svg";